import { colors } from '@ardoq/design-tokens';
import { Icon } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { BreadcrumbTrailProps } from './types';
import { HighlightedText } from '../HighlightedText';
import { WrapperWithEllipsisOverflow } from '@ardoq/popovers';

export const BreadcrumbTrail = ({
  breadcrumbs,
  textStyles,
}: BreadcrumbTrailProps) => (
  <FlexBox align="center" flexWrap={false}>
    {breadcrumbs.map(({ text, icon, gap, highlight }, index) => (
      <FlexBox key={index} align="center" gap={gap} flexWrap={false}>
        <Icon iconName={icon.name} color={colors.icon} iconSize={icon.size} />
        <span
          style={{
            whiteSpace: 'nowrap',
            ...textStyles,
          }}
        >
          <WrapperWithEllipsisOverflow $lineClamp={1}>
            <HighlightedText text={text} highlight={highlight} />
          </WrapperWithEllipsisOverflow>
        </span>
      </FlexBox>
    ))}
  </FlexBox>
);
